import React from 'react'

import { StatusScreen } from '../../StatusScreen'
import { MoySkladOrdersScreen } from './MoySkladOrdersScreen'
import { MoySkladSettingsScreen } from './MoySkladSettingsScreen'
import { MoySkladSyncLogsScreen } from '../../MoySkladSyncLogsScreen'
import { MoySkladProductsTableScreen } from './MoySkladProductsTableScreen'
import { RouteTabSwitchItems, RoutingTabsSwitch } from '../../RoutingTabsSwitch'
import { MoySkladAdditionalPropertiesSettings } from './MoySkladAdditionalPropertiesSettings'

import { appRoutes } from '../../../common/appRoutes'

const ordersRoute = {
  title: 'Заказы',
  path: appRoutes.MoySklad.orders,
  render: () => <MoySkladOrdersScreen/>
} as const satisfies RouteTabSwitchItems[number]

const routes = [{
  title: 'Статусы',
  path: appRoutes.MoySklad.status,
  render: () => <StatusScreen/>
}, {
  title: 'Товары',
  path: appRoutes.MoySklad.products,
  render: () => <MoySkladProductsTableScreen/>
},
  ordersRoute, {
    title: 'Настройка',
    path: appRoutes.MoySklad.settings,
    render: () => <MoySkladSettingsScreen/>
  }, {
    title: 'Доп. Поля',
    path: appRoutes.MoySklad.attributes,
    render: () => <MoySkladAdditionalPropertiesSettings/>
  }, {
    title: 'Логи',
    path: appRoutes.MoySklad.syncLogs,
    render: () => <MoySkladSyncLogsScreen/>
  }] as const satisfies RouteTabSwitchItems

export const MoySkladAccountRoute = () =>
  <div className="body_wrapper_zero body_wrapper__home">
    <RoutingTabsSwitch routeTabs={routes} fallbackRoute={ordersRoute}/>
  </div>